import { render, staticRenderFns } from "./InstructionsCard.vue?vue&type=template&id=f707e388&"
import script from "./InstructionsCard.vue?vue&type=script&lang=js&"
export * from "./InstructionsCard.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports